<template>
  <div class="sidebar">
    <el-menu
       :default-active="activeMenu"
       route
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      background-color="#F2F7FF"
      text-color="#000"
      active-text-color="#0981f1"
    >
      <!-- <h3>{{ isCollapse ? "后台" : systemName }}</h3> -->

      <common-menu-item-aside :menuItemData="menuData" />
    </el-menu>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { SYSTEM_NAME } from "@/constant/Const";
import CommonMenuItemAside from "./CommonMenuItemAside.vue";
import { useRouter, useRoute } from 'vue-router';

const route = useRoute();
// 默认激活的菜单
const activeMenu = computed(() => route.path)



const systemName = SYSTEM_NAME;
const store = useStore();

/* 是否折叠 */
const isCollapse = computed(() => store.state.tab.isCollapse);

/* 菜单数据 */
const menuData = computed(() => {
  
  return store.state.tab.menuList;
});

/* 打开/关闭菜单 */
const handleOpen = (key, keyPath) => {};
const handleClose = (key, keyPath) => {};

/* 加载 sessionStorage 的 menuList */
onMounted(() => {
  const storedMenuList = JSON.parse(window.sessionStorage.getItem("menuList"));
  if (storedMenuList) {
    store.dispatch("updateMenuList", storedMenuList);
  }
});
</script>

<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 100vh;
}
.sidebar{
  height: 100vh;
}
.el-menu {
  // height: 100%;
  border-right: none;

  h3 {
    color: #fff;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
